import { render, staticRenderFns } from "./Substatus.html?vue&type=template&id=04ca38bc&"
import script from "./Substatus.js?vue&type=script&lang=js&"
export * from "./Substatus.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports